import { SET_DELIVERY_CHANGE_SETTINGS, SET_DELIVERY_SETTINGS_BEEPER_CONFIGS, SET_DELIVERY_SETTINGS_CART_SETTINGS, UPDATE_DELIVERY_CHANGE_SETTING, UPDATE_DELIVERY_SETTINGS_CART_SETTING } from '../../actionTypes/deliverySettings'

const initialState = {
	cartSettings: [],
	changeSettings: [],
	beeperConfigs: null
}

export function deliverySettingsReducer (state = initialState, action) {
	switch (action.type) {
		case SET_DELIVERY_SETTINGS_CART_SETTINGS:
			return {
				...state,
				cartSettings: action.value,
			}
		case UPDATE_DELIVERY_SETTINGS_CART_SETTING:
			const updateCartSettings = [...state.cartSettings].map(item => item.businessScope === action.value.businessScope ? action.value : item)
			return {
				...state,
				cartSettings: updateCartSettings,
			}
		case SET_DELIVERY_CHANGE_SETTINGS:
			return {
				...state,
				changeSettings: action.value,
			}
		case UPDATE_DELIVERY_CHANGE_SETTING:
			const updateChangeSettings = [...state.changeSettings].map(item => item.businessScope === action.value.businessScope ? action.value : item)
			return {
				...state,
				changeSettings: updateChangeSettings,
			}
		case SET_DELIVERY_SETTINGS_BEEPER_CONFIGS:
			return {
				...state,
				beeperConfigs: action.value,
			}
		default:
			return state
	}
}
